import * as csv from '../services/csv'
import * as algolia from '../services/algolia'
import { USER_TYPE } from '../constant'
import { getConstantKey } from '../helpers'


export const exportWaiting = () => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  const users = await algolia.browse(algolia.user, '', {
    tagFilters: ['waiting_approval'],
  })

  csv.csvUsers(users, USER_TYPE.ALL, 'waiting_approval')
  dispatch({ type: 'UNLOAD' })
}

export const exportRejected = () => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  const users = await algolia.browse(algolia.user, '', {
    tagFilters: ['rejected'],
  })

  csv.csvUsers(users, USER_TYPE.ALL, 'waiting_approval')
  dispatch({ type: 'UNLOAD' })
}


export const exportsUsersCSV = (type = USER_TYPE.MODEL) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  const userType = getConstantKey(USER_TYPE, type) || ''
  const users = await algolia.browse(algolia.user, '', {
    tagFilters: [userType, 'validated'],
  })

  csv.csvUsers(users, USER_TYPE.ALL, `user_${userType.toLowerCase()}`)
  dispatch({ type: 'UNLOAD' })
}

export const exportsCastingsCSV = () => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  const castings = await algolia.browse(algolia.casting, '')

  csv.csvCastings(castings)
  dispatch({ type: 'UNLOAD' })
}


export const exportsCastingsProfilesCSV = () => async (dispatch, getState) => {
  const { casting } = getState().castings

  csv.csvCastingProfiles(casting.profiles)
}
